import * as yup from "yup";

export interface WrotevoteRespondModel {
    Comment?: string;
    ReplyID: number;
}

export const WrotevoteRespondModelValidationSchema = yup.object().shape<WrotevoteRespondModel>({
    Comment: yup.string().optional(),
    ReplyID: yup.number().required(),
});
